import {
  AGREGAR_FAVORITO,
  APPEND_VIDEOS,
  CLEAR_RELOAD,
  CREATE_VIDEO,
  ELIMINAR_FAVORITO,
  FAVORITOS_RECEIVED,
  HIDE_SPINNER,
  PROGRAMS_RECEIVED,
  PURCHASE_NEEDED,
  SET_COMPLETED,
  SET_NONCE,
  SET_PROPERTY_VIDEO,
  SHOW_SPINNER,
  SINGLE_VIDEO_RECEIVED,
  TAGS_RECEIVED,
  VIDEOS_RECEIVED,
} from "../types";

const schema = {
  video_id: "nuevo",
  description: "",
  name: "",
  restricted: "",
  thumbnail: "",
  url: "",
  url_preview: "",
  instructor_id: "",
  video_type_id: "",
  video_type: "",
};

export default (state, { type, payload }) => {
  switch (type) {
    case SHOW_SPINNER: {
      return { ...state, spinner: true };
    }
    case HIDE_SPINNER: {
      return { ...state, spinner: false };
    }
    case CREATE_VIDEO: {
      return { ...state, video: schema };
    }
    case FAVORITOS_RECEIVED:
      return { ...state, favoritos: payload };
    case APPEND_VIDEOS: {
      let videos = state.videos;
      if (videos === null) videos = payload;
      else videos = [...videos, ...payload];
      return { ...state, videos };
    }
    case VIDEOS_RECEIVED: {
      const { videos, nonce } = payload;
      if (nonce === state.nonce) {
        return { ...state, videos, allVideos: videos };
      }
      return { ...state };
    }
    case SINGLE_VIDEO_RECEIVED:
      return { ...state, video: payload };
    case AGREGAR_FAVORITO: {
      const videos = [...state.videos];
      const index = videos.findIndex((video) => video.video_id === payload);
      if (index !== -1) {
        videos[index].favorite = 1;
      }
      return { ...state, videos, reloadVideos: true };
    }
    case ELIMINAR_FAVORITO: {
      const videos = [...state.videos];
      const index = videos.findIndex((video) => video.video_id === payload);
      if (index !== -1) {
        videos[index].favorite = 0;
      }
      return { ...state, videos, reloadVideos: true };
    }
    case SET_PROPERTY_VIDEO: {
      const { key, value } = payload;
      const video = { ...state.video };
      video[key] = value;
      return { ...state, video };
    }
    case PURCHASE_NEEDED:
      return { ...state, purchase_needed: true };
    case TAGS_RECEIVED:
      return { ...state, tags: payload };
    case PROGRAMS_RECEIVED:
      return { ...state, programs: payload };
    case SET_COMPLETED: {
      return { ...state, completed: payload };
    }
    case CLEAR_RELOAD:
      return { ...state, reloadVideos: false };
    case SET_NONCE:
      return { ...state, nonce: payload };
    default:
      return { ...state };
  }
};
